import { Wrapper } from 'components/wrapper';

import { HeaderProps } from './types';

export const Header = ({
  title,
  logoSrc = '/images/logo-name.svg',
}: HeaderProps) => {
  return (
    <header className="bg-accent-gradient-primary relative z-50">
      <i className="absolute bottom-0 left-0 h-42 w-36.25 bg-[url('/images/header-bg-l.svg')] bg-no-repeat md:h-86 md:w-118.25 md:bg-[url('/images/header-bg-l-d.svg')]" />
      <i className="absolute top-0 right-0 h-42 w-83.5 bg-[url('/images/header-bg-r.svg')] bg-no-repeat md:h-86 md:w-138 md:bg-[url('/images/header-bg-r-d.svg')]" />

      <Wrapper className="relative z-10">
        <div className="flex flex-col items-center gap-2 py-4 text-center text-white md:py-6 lg:gap-6 lg:pt-6 lg:pb-5">
          <div className="flex items-start">
            <img width="304" alt={title} height="200" src={logoSrc} />
          </div>
        </div>
      </Wrapper>
    </header>
  );
};
